import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ChakraProvider, extendTheme } from '@chakra-ui/react'
import './index.css'
import App from './App.jsx'
import * as Sentry from '@sentry/react'
import { BrowserTracing } from '@sentry/tracing'

// Initialize Sentry before React app creation
if (import.meta.env.VITE_SENTRY_LOGGING === 'true' && import.meta.env.VITE_SENTRY_DSN) {
  const apiUrl = (import.meta.env.VITE_API_URL || 'http://localhost:8000').replace(/\/$/, '');
  const tunnelUrl = `${apiUrl}/api/sentry-tunnel`;

  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || 'frontend',
    tunnel: tunnelUrl,
    integrations: [
      new BrowserTracing(),
      new Sentry.Replay({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    beforeSend(event) {
      // Add [frontend] prefix to all messages
      if (event.message && !event.message.startsWith('[frontend]')) {
        event.message = `[frontend] ${event.message}`;
      }
      return event;
    },
  });

  // Make Sentry globally available for logger
  window.Sentry = Sentry;

  console.log('[sentry] Initialized Sentry for environment:', import.meta.env.VITE_SENTRY_ENVIRONMENT || 'frontend');
  console.log('[sentry] Using tunnel:', tunnelUrl);
}

const theme = extendTheme({
  config: {
    initialColorMode: 'dark',
    useSystemColorMode: false,
  },
  styles: {
    global: {
      body: {
        bg: '#09090b',
        color: '#d4d4d8',
      },
    },
  },
  colors: {
    brand: {
      50: '#fff7ed',
      100: '#ffedd5',
      200: '#fed7aa',
      300: '#fdba74',
      400: '#fb923c',
      500: '#f97316',
      600: '#ea580c',
      700: '#c2410c',
      800: '#9a3412',
      900: '#7c2d12',
    },
  },
})

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ChakraProvider theme={theme}>
      <BrowserRouter>
        <Sentry.ErrorBoundary fallback={<div style={{ padding: '20px', textAlign: 'center' }}>
          <h1>Something went wrong</h1>
          <p>We're sorry for the inconvenience. Please refresh the page.</p>
        </div>} showDialog>
          <App />
        </Sentry.ErrorBoundary>
      </BrowserRouter>
    </ChakraProvider>
  </StrictMode>,
)
